export interface BiometryNativeResponseModel {
	biometry: Biometry;
}

export interface Biometry {
	biometry_status: BiometryStatus[];
	biometry_show_dialog: boolean;
	error?: string;
}

export enum BiometryStatus {
	Enabled = 'Enabled',
	Enable_KeyGuard_in_Settings = 'Enable_KeyGuard_in_Settings',
	RequestPermission_Use_Biometric = 'RequestPermission_Use_Biometric',
	RequestPermission_Use_Fingerprint = 'RequestPermission_Use_Fingerprint',
	No_Hardware_Fingerprint = 'No_Hardware_Fingerprint',
	No_Enrolled_Fingerprint = 'No_Enrolled_Fingerprint',
}

export interface BiometryAuthResponse {
	success: boolean;
	biometry_data?: Biometry;
	error?: string;
}
